var map = {
	"./DS_DZHR1_201907200653149_KZ1_E066N50_017688_QL.webp": 500,
	"./angle.webp": 827,
	"./bg3.webp": 828,
	"./bg4.webp": 829,
	"./clear.webp": 501,
	"./cloud.webp": 830,
	"./lasso-plus.webp": 502,
	"./lasso.webp": 255,
	"./logoKGS.webp": 831,
	"./magic-wand-plus.webp": 503,
	"./magic-wand.webp": 256,
	"./noavatar.webp": 102,
	"./search.webp": 504,
	"./sun.webp": 832,
	"./zoom-in.webp": 357,
	"./zoom-out.webp": 505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 499;